import { render, staticRenderFns } from "./PublicFooter.vue?vue&type=template&id=0e773d8b&scoped=true&"
import script from "./PublicFooter.vue?vue&type=script&lang=js&"
export * from "./PublicFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e773d8b",
  null
  
)

export default component.exports